const SectionAbout = () => (
  <section id="about" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="max-w-[800px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于吃瓜网每日大赛</h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
              <i className="ri-compass-3-line text-lg"></i>
            </span>
            <h3 className="mt-3 text-base font-semibold text-foreground-900">我们的使命</h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              吃瓜网每日大赛致力于打造中文互联网最全、最快、最真实的娱乐八卦资讯聚合平台。我们追踪明星动态、深挖行业黑幕、还原事件真相，让每一颗"瓜"都有据可查。
            </p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
              <i className="ri-shield-star-line text-lg"></i>
            </span>
            <h3 className="mt-3 text-base font-semibold text-foreground-900">内容准则</h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              我们坚持「有料不造谣」原则，所有爆料均经过多方核实。对于未经证实的传闻，我们会明确标注「待核实」标签，绝不为了流量而传播虚假信息。
            </p>
          </div>
          <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
              <i className="ri-group-line text-lg"></i>
            </span>
            <h3 className="mt-3 text-base font-semibold text-foreground-900">社区文化</h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
              吃瓜不是目的，真相才是追求。我们鼓励理性讨论，拒绝网络暴力。在吃瓜网每日大赛，每一位瓜友都能找到属于自己的吃瓜节奏。
            </p>
          </div>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-8">
          <div className="text-center">
            <p className="text-3xl font-heading font-bold text-primary-500">5000+</p>
            <p className="text-sm text-foreground-500 mt-1">独家爆料</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-heading font-bold text-accent-500">200万+</p>
            <p className="text-sm text-foreground-500 mt-1">日活瓜友</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-heading font-bold text-primary-500">99.7%</p>
            <p className="text-sm text-foreground-500 mt-1">准确率</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default SectionAbout;